import { useMutation } from 'react-query';

import { queryClient } from '@/utils/react-query';

import client from '../client';

export const markNotificationsAsRead = async ({
  notificationIDs,
}: {
  notificationIDs: 'all' | number[];
}): Promise<void> => {
  await client.put<void>(`api/notifications/read`, {
    notificationIDs: notificationIDs,
  });
};

export const useMarkNotificationsAsRead = () => {
  return useMutation({
    onSettled: () => {
      // Invalidate notification related caches
      queryClient.invalidateQueries(['notifications']);
      queryClient.invalidateQueries(['unreadNotificationCount']);
    },
    mutationFn: markNotificationsAsRead,
  });
};
